import React, { useContext } from "react";
import {
  ComponentSingleStyleConfig,
  Text,
  Tooltip,
  useStyleConfig,
} from "@chakra-ui/react";
import { TipDelayContext } from "../../../contexts/TipDelayContext";
import { useFormattedDate } from "../../../hooks/use-formatted-date";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";

export type CMDatetimeTextProps = {
  value?: Date;
} & ComponentStyleProps;

export const CMDatetimeText = ({
  value,

  sx,
  ...rest
}: CMDatetimeTextProps) => {
  const styles = useStyleConfig("CMDatetimeTextStyles");

  const tipDelay = useContext(TipDelayContext);

  const { shortDatetimeText, fullDatetimeText } = useFormattedDate(value, {
    shortDatetime: true,
    fullDatetime: true,
  });

  return (
    <Tooltip label={fullDatetimeText} openDelay={tipDelay.md}>
      <Text sx={{ ...styles, ...sx }} {...rest}>
        {shortDatetimeText}
      </Text>
    </Tooltip>
  );
};

export const CMDatetimeTextStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    whiteSpace: "nowrap",
  },
};
